import React, { Component } from 'react';
import { Text, View, FlatList, AppState, StyleSheet, Image, Pressable } from 'react-native';
import {
  registerNotificationReceivedHandler,
  unRegisterNotificationReceivedHandler,
  handleNotification,
} from '../../notificationsHandlers';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getNotificationsArray } from '../../selectors/entities';

import { getNotifications, markNotificationAsRead, markAllNotificationsAsRead } from './actions';
import { OPComponent, ActivityOverlay, Utils, NavBar, I18n, Navigation } from '../components';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { SUCCESS, FAILED, PENDING, REQUESTING } from '../../actions/statusTypes';

import ListItem from './list_item';

class Notifications extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyleRootScreen;
  static navigatorButtons = NavBar && {
    leftButtons: [NavBar.buttons.done],
    rightButtons: [
      {
        component: {
          name: 'ClearAllNotificationsNavbarButton',
        },
        id: 'clear_all',
      },
    ],
  };

  constructor(props) {
    super(props);

    this._unMounted = false;
    this._screenVisible = false;

    this.state = {};
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress(componentId, buttonId)) return;
  };
  handleDeepLink = ({ link, payload }) => {
    switch (link) {
      case 'notifications/clearAll':
        Utils.trackEvent('Action', 'Tap', 'Clear All Notifications');
        this.clearAll();
        break;
      case 'notifications/main':
        Navigation.showModal({
          screen: 'Notifications',
          title: I18n.ac('labelNotifications'),
        });
        break;
    }
  };

  // for now trigger data to refresh when the screen becomes visible, or
  // when the app comes to the foreground with this screen visible. But
  // its probably better actually to trigger the notifications state to update
  // automatically when the badge event is triggered.\
  componentDidMount() {
    Utils.trackScreen('Notifications', 'Notifications');
    Navigation.registerForButtonEvents(this);
    this._appStateListener = AppState.addEventListener('change', this._handleAppStateChange);

    registerNotificationReceivedHandler(this._handlePushReceived);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this._unMounted = true;
    this._screenVisible = false;

    unRegisterNotificationReceivedHandler(this._handlePushReceived);
    this._appStateListener.remove();
  }
  componentDidAppear(id) {
    this._screenVisible = true;
    this.refreshData();
  }
  componentDidDisappear(id) {
    this._screenVisible = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearStatus === SUCCESS && prevProps.clearStatus !== SUCCESS) {
      this.refreshData();
    }
    // in web the screen isn't appearing / disappearing so trigger fetching here
    if (__WEB__ && prevProps.badge !== this.props.badge) {
      this.refreshData();
    }
  }

  _handlePushReceived = (notification) => {
    if (this._unMounted) return false;

    if (this._screenVisible) {
      this.refreshData();
      return true;
    }
    return false;
  };

  _handleAppStateChange = (newAppState) => {
    if (this._unMounted) return;

    if (newAppState == 'active') {
      if (this._screenVisible) {
        this.refreshData();
      }
    }
  };

  refreshData() {
    this.props.actions.getNotifications();
  }

  clearAll = () => {
    this.props.actions.markAllNotificationsAsRead(
      this.props.notifications.map((n) => n.notificationId)
    );
  };

  renderItem = ({ item }) => {
    return (
      <ListItem
        item={item}
        onPress={() => this.handleItemPress(item)}
        onDismiss={() => this.handleItemDismiss(item)}
      />
    );
  };

  handleItemDismiss(notification) {
    this.props.actions.markNotificationAsRead(notification.notificationId);
  }

  handleItemPress(item) {
    handleNotification({
      data: {
        ...(item.payload && item.payload.data),
        notificationId: item.notificationId,
      },
    });
  }

  render() {
    if (!this.props.fullSync) {
      return <View style={styles.container} />;
    } else if (!this.props.notifications.length) {
      if (this.props.clearStatus === REQUESTING || this.props.fetchStatus === REQUESTING) {
        return (
          <View style={styles.container}>
            <ActivityOverlay sizeToScreen={true} />
          </View>
        );
      }
      return (
        <View style={styles.noNotificationsContainer}>
          <Image
            source={require('../../../resources/icon-bell-circle.png')}
            style={styles.noNotificationsIcon}
          />
          <Text style={styles.noNotificationsText}>{I18n.ce('notifications.allCaughtUp')}</Text>
        </View>
      );
    } else {
      return (
        <View style={styles.container}>
          {!!__WEB__ && (
            <View style={styles.webHeader}>
              <Pressable onPress={this.clearAll}>
                <Text style={THEME.linkStyle}>Clear All</Text>
              </Pressable>
            </View>
          )}
          <FlatList
            data={this.props.notifications}
            renderItem={this.renderItem}
            keyExtractor={(item) => item.notificationId}
          />
        </View>
      );
    }
  }
}

const styles = StyleSheet.create({
  container: THEME.container,
  noNotificationsContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: __WEB__ ? 50 : 125,
    backgroundColor: COLOR.contrast,
  },
  noNotificationsIcon: {
    width: 129,
    height: 129,
  },
  noNotificationsText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.large,
  },
  webHeader: {
    backgroundColor: COLOR.contrast,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
    height: 40,
    paddingHorizontal: 20,
    justifyContent: 'center',
  },
});

function mapStateToProps(state, ownProps) {
  return {
    currentCaseId: state.application.currentCaseId,
    notifications: getNotificationsArray(state),
    fullSync: state.user.fullSync,
    badge: state.entities.notifications.badge,
    clearStatus: state.screens.notifications.clearStatus,
    fetchStatus: state.screens.notifications.fetchStatus,
    errorMessage: state.screens.notifications.errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getNotifications,
        markNotificationAsRead,
        markAllNotificationsAsRead,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
